module.exports = __webpack_public_path__ + "static/media/individual_01.c61cb404.jpg";